import Vue3Toastify, { toast } from 'vue3-toastify'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(Vue3Toastify, {
    position: 'bottom-right',
    transition: 'slide',
    newestOnTop: true,
    icon: false,
  })

  return {
    provide: { toast },
  }
})
